const swUrl = `${process.env.PUBLIC_URL || ''}/vmk-sw.js`;

export function registerServiceWorker() {
  if (!('serviceWorker' in navigator)) return;

  window.addEventListener('load', () => {
    navigator.serviceWorker
      .getRegistrations()
      .then((registrations) =>
        Promise.all(
          registrations.map((registration) => {
            const scriptUrl =
              registration.active?.scriptURL ||
              registration.installing?.scriptURL ||
              registration.waiting?.scriptURL ||
              '';
            if (scriptUrl.endsWith('/sw.js')) {
              return registration.unregister();
            }
            return Promise.resolve(false);
          }),
        ),
      )
      .then(() => navigator.serviceWorker.register(swUrl))
      .catch(() => {
        /* Non-HTTPS or blocked: ignore. */
      });
  });
}
